import './LoadingSpinner.css';

export default function LoadingSpinner({ message = 'Loading...', size = 'medium', className = '' }) {
  return (
    <div className={`LoadingSpinner ${size} ${className}`}>
      <div className="spinner">
        <div className="spinner-circle"></div>
      </div>
      <div className="spinner-message">{message}</div>
    </div>
  );
}
